// Generated by CoffeeScript 1.12.7
(function () {
  var DeleteBlockController;

  module.exports = DeleteBlockController = (function () {
    function DeleteBlockController(createUi, block, closeMenu, deleteBlock) {
      this.ui = createUi(require("Project/BlockNew/Menu/DeleteBlock/DeleteBlock.html"), {
        cancel: closeMenu,
        deleteBlock: (function (_this) {
          return function () {
            return deleteBlock(block);
          };
        })(this),
      });
    }

    return DeleteBlockController;
  })();
}.call(this));
